"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = require("react");

/**
 * Options for the victory line plugin.
 *
 * @typedef victoryLinePluginOptions
 * @type {object}
 * @property {object} theme - The Victory theme being used for the chart (i.e.
 *   the object returned from the `useVictoryTheme` hook).
 */

/**
 * Integrate a VictoryLine component with the Meridian Legend.
 *
 * See the [Line data visualization documentation](https://meridian.a2z.com/data-visualization/line/?platform=react-web)
 * for details on usage.
 *
 * @param {victoryLinePluginOptions} options - Configuration for the plugin.
 *
 * @return {*} - The instantiated plugin to be passed to the `LegendProvider`
 *   component's `plugins` prop.
 */
var victoryLinePlugin = function victoryLinePlugin(_ref) {
  var theme = _ref.theme;
  return function (legend) {
    /**
     * Generates props for a VictoryLine component given the legend key of the
     * data.
     */
    var getLineProps = (0, _react.useCallback)(function (key) {
      return {
        style: {
          data: {
            key: key,
            stroke: legend.getItem(key).color,
            filter: (0, _typeof2["default"])(theme.line.style.data.filter) !== undefined && legend.getState(key) !== "inactive" ? theme.line.style.data.filter : "inherit",
            strokeOpacity: legend.getState(key) === "inactive" ? 0.2 : 1,
            transition: "stroke-opacity filter 0.2s ease"
          }
        }
      };
    }, [legend]);
    /**
     * Generates props for a VictoryScatter component (used to draw points on a
     * line) given the legend key of the data.
     */

    var getScatterProps = (0, _react.useCallback)(function (key) {
      return {
        style: {
          data: {
            key: key,
            fill: theme.chart.background.fill,
            stroke: legend.getItem(key).color,
            opacity: legend.getState(key) === "inactive" ? 0.2 : 1,
            strokeOpacity: legend.getState(key) === "inactive" ? 0.2 : 1,
            strokeWidth: theme.line.style.data.strokeWidth,
            transition: "opacity 0.2s ease"
          }
        },
        // Scale the size down as the stroke width of the line gets larger so the
        // visual size stays the same
        size: 7 - theme.line.style.data.strokeWidth / 2,
        symbol: legend.getItem(key).symbol
      };
    }, [legend]);
    return {
      api: {
        getLineProps: getLineProps,
        getScatterProps: getScatterProps,
        voronoiContainerProps: {
          title: legend["aria-label"],
          "aria-describedby": legend["aria-describedby"],
          "aria-labelledby": legend["aria-labelledby"]
        }
      }
    };
  };
};

var _default = victoryLinePlugin;
exports["default"] = _default;